export const CheckIcon = ({ className }: { className?: string }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M10.125 3.375L4.875 8.625L2.25 6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
